<template>
  <div class="DiaryView" v-if="diaryEntry.performingCompanies && currentProject._id">
    <div class="diaryContainer">
      <div class="current-day">
        <h2 class="light">{{ $t(currentDayName) }}</h2>
        <h2 class="bold">{{ diaryEntry.diaryDate }}</h2>
      </div>

      <Weather :currentdate="diaryEntry.diaryDate" :city="projectCity" />
      <div>
        <div v-if="diaryEntry.noWorkPerformed">
          {{ $t('No Work Performed this date') }}
        </div>
        <div class="total-count">
          {{ $t('Sub contractor check')
          }}<span>
            {{ $t('{companies} companies on site', { companies: diaryEntry.performingCompanies.length }) }}</span
          >
        </div>
        <div class="comment-list">
          <ul>
            <li v-for="(item, index) in diaryEntry.performingCompanies" :key="index" v-show="item.companyId">
              {{ company(item.companyId).companyName }} <span>( {{ companyTotalPerson[index] }} st )</span>
              <span class="comment" v-for="(comment, i) in item.diaryEntries" :key="i"
                >{{ comment.numberOfWorkers }} st {{ comment.comment }}</span
              >
            </li>
          </ul>
        </div>
        <div v-if="hasPermissionsToViewOtherComments" class="other-text">
          {{ $t('Other comments') }}
          <p style="white-space: pre-wrap">{{ diaryEntry.summary }}</p>
        </div>
      </div>
      <div class="user">
        <div>
          <p style="font-weight: 500">{{ $t('Created by') }}</p>
          <p>{{ personName(diaryEntry.currentUserId) }}</p>
          <p v-if="diaryEntry.createdAt">{{ formatDate(diaryEntry.createdAt) }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { fuzzytime } from '@/common/timeHelpers';
import moment from 'moment';

import Weather from '@/components/diary/Weather';
export default {
  name: 'DiarySummary',
  props: ['diaryEntry', 'projectCity'],
  methods: {
    formatDate(dat) {
      return this.$t(fuzzytime(dat));
    },
    company: function (companyId) {
      return this.getCompany(companyId);
    },
  },
  computed: {
    ...mapGetters(['currentProject', 'personName', 'getCompany', 'hasSimplePermissions']),
    currentDayName: function () {
      return moment(this.diaryEntry.diaryDate).format('dddd');
    },
    companyTotalPerson: function () {
      return this.diaryEntry.performingCompanies.flatMap((company) => {
        return company.diaryEntries.reduce((agg, curr) => {
          return agg + Number(curr.numberOfWorkers);
        }, 0);
      });
    },

    hasPermissionsToViewOtherComments() {
      return this.hasSimplePermissions('diaryEntryViewOtherComments');
    },
  },
  components: {
    Weather,
  },
};
</script>

<style scoped>
/* @font-face {
    font-family: 'Montserrat-ThinItalic';
    src: local('Montserrat-ThinItalic'), local('Montserrat-ThinItalic'), url(/static/fonts/Montserrat-ThinItalic.ttf) format('ttf');
  } */
@import url('https://fonts.googleapis.com/css?family=Cabin:400,500,500i,600,700|Montserrat+Alternates|Montserrat:300,300i,400,500,600,600i&display=swap" rel="stylesheet');
.DiaryView {
  display: flex;
  flex-direction: column;
  /* min-height: calc(100vh - 100px); */
  padding: 0 20px;
  color: #fff;
  overflow-y: auto;
}

.diaryContainer {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
}

.top {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  margin-bottom: 15px;
}

.top img {
  width: 30px;
  height: 30px;
  cursor: pointer;
}
.diaryContainer .title {
  font-size: 18px;
  font-weight: 100;
  margin-bottom: 5px;
}

.titles {
  padding-top: 10px;
}

.total-count {
  font-size: 14px;
  padding: 20px 0;
  border-bottom: 1px solid #253747;
  font-weight: bold;
  color: #fff;
  text-transform: uppercase;
}
.total-count span {
  font-size: 11px;
  font-weight: normal;
}
.comment-list {
  margin-top: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #253747;
}
.comment-list ul {
  list-style: none;
}
.comment-list ul li {
  font-size: 14px;
  margin-bottom: 10px;
  font-weight: 400;
  max-height: 400px;
}
.comment-list ul li .comment {
  display: block;
  font-size: 12px;
  margin-top: 3px;
  font-family: Cabin !important;
  font-weight: normal;
  color: #d1d3d4;
}
.other-text {
  margin-top: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #253747;
  font-size: 14px;
  font-weight: bold;
  color: #fff;
}
.other-text span {
  font-size: 11px;
  font-weight: 200;
  font-style: italic;
  color: #fff;
}
.other-text p {
  font-size: 12px;
  font-weight: 200;
  color: #fff;
}
.user {
  margin-top: 15px;
  text-align: center;
  justify-self: flex-end;
}
.user p {
  font-size: 14px;
  font-weight: 100;
  font-family: 'Montserrat', sans-serif;
  font-style: italic;
}

.current-day {
  display: flex;
  margin-bottom: 10px;
}

.current-day .light {
  font-weight: lighter;
  margin-right: 5mm;
}
</style>



// WEBPACK FOOTER //
// src/components/diary/DiarySummary.vue